<template>
  <form-section :title="title" class="device-information-card">
    <el-col v-for="(item, index) in items" :key="index" :span="12">
      <form-item :label="item.label">
        <div class="item-box">
          <i v-if="item.icon" :class="item.icon"></i>
          <flag v-if="item.flag" class="flag" :iso="item.flag" />
          <div class="item-value" data-qa="device-info-value">
            <overflow-tooltip :value="item.value" />
          </div>
          <el-button
            v-if="canCopy(item)"
            type="text"
            class="copy-btn"
            data-qa="copy-token-btn"
            @click="copyToClipboard(item.value)"
          >
            <i class="el-icon-copy-document" />
          </el-button>
        </div>
      </form-item>
    </el-col>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'

export default {
  name: 'DeviceInformationCard',

  components: {
    OverflowTooltip,
    FormItem,
    FormSection
  },

  props: {
    title: {
      type: String,
      required: true
    },

    items: {
      type: Array,
      required: true
    }
  },

  methods: {
    canCopy(item) {
      return (
        item.label === this.$t('Profiles_Devices_Field_Token') &&
        item.value &&
        item.value !== '-'
      )
    },
    copyToClipboard(value) {
      navigator.clipboard.writeText(value).then(() => {
        this.$message({
          message: this.$t('Profiles_Devices_Field_Token_Copied'),
          type: 'success'
        })
      })
    }
  }
}
</script>

<style scoped>
.device-information-card {
  width: 100%;
  height: 100%;
}

>>> .content {
  background-color: #f8fafc;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}

.device-info-value-container i {
  align-self: center;
}

.item-box {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.item-value {
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.el-icon-empty-icon {
  margin-left: 3px;
  margin-right: 8px;
  background: #e6e6e6;
  border-radius: 8px;
  width: 16px;
  height: 16px;
}

.el-icon-empty-icon .empty-icon {
  background: none;
}

.el-icon-success {
  margin-left: 3px;
  margin-right: 8px;
  background: #1fca10;
  border-radius: 8px;
  width: 16px;
  height: 16px;
  color: transparent;
}

.flag {
  font-size: 14px;
  margin-right: 8px;
  border-radius: 2px;
}

.copy-btn {
  padding: 0;
  margin-left: 8px;
  font-size: 16px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/devices/components/DeviceInformationCard.vue